import { useAtomValue } from 'jotai';

import { SetState } from '../../../../../types/helper';
import MobileFreeBadge from '../../../../@common/FreeBadge/Mobile';
import MobilePageChangeEffectLayer from '../../../../@common/Layer/MobilePageChangeEffectLayer';
import MobileIntro from '../../../../@common/Intro/Mobile';
import MobileAnnotationLayer from '../../../../@common/Layer/OneOnOneAnnotationLayer/Mobile';
import MobilePageWrapper from '../../../../@common/PageWrapper/Mobile';
import MobilePage from '../../../../@common/Viewer/Mobile';
import { PdfViewerRedirect } from '../../../index.types';
import { currentPageAtom } from '../../../../../store/index.atom';
import { thumbnailsAtom } from '../../index.atom';
import MobilePageNavigationButton from '../../../../@common/PageNavigationButton/Mobile';
import MobileViewerLayer from '../../../../@common/Layer/DefaultViewerLayer/Mobile';

interface Props {
  data?: PdfViewerRedirect;
  domain?: string;
  translateKoToEn: (item: string) => string;
  updateNextThumbnails: (page: number) => void;
  updatePrevThumbnails: (page: number) => void;
  setIsMobileDrawerOpen: SetState<boolean>;
  isBulk: boolean;
  isMobileLandscape: boolean;
}

const Mobile = ({
  data,
  domain,
  translateKoToEn,
  setIsMobileDrawerOpen,
  isBulk = false,
  isMobileLandscape,
  updateNextThumbnails,
  updatePrevThumbnails,
}: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const thumbnails = useAtomValue(thumbnailsAtom);

  if (!data) {
    return null;
  }

  const { isDownloadEnabled, name, thumnail, pages, userSubscriptionPlan } =
    data;

  const isNextPageButtonDisabled = currentPage >= thumnail?.length;

  return (
    <>
      <MobileIntro translateKoToEn={translateKoToEn} />

      <MobilePageWrapper
        totalPage={data.pages}
        updateNextThumbnails={updateNextThumbnails}
        updatePrevThumbnails={updatePrevThumbnails}
      >
        <MobilePage
          thumnails={thumbnails?.map((value) => {
            if (value?.thumnail) {
              return {
                src: value.thumnail,
                imageSources: value.imageSources,
              };
            }
            return null;
          })}
          isMobileLandscape={isMobileLandscape}
        />

        <MobilePageChangeEffectLayer />

        <MobilePageNavigationButton
          totalPage={Number(pages)}
          isNextPageButtonDisabled={isNextPageButtonDisabled}
          isMoveCtaFormPageRequirements={true}
          openDrawer={() => setIsMobileDrawerOpen(true)}
          updateNextThumbnails={updateNextThumbnails}
          updatePrevThumbnails={updatePrevThumbnails}
          isMobileLandscape={isMobileLandscape}
        />

        <MobileFreeBadge userSubscriptionPlan={userSubscriptionPlan} />

        <MobileViewerLayer
          domain={domain}
          fileName={name}
          isBulk={isBulk}
          translateKoToEn={translateKoToEn}
          isDownloadEnabled={isDownloadEnabled}
          isMobileLandscape={isMobileLandscape}
        />
        {thumnail && <MobileAnnotationLayer thumnail={thumnail} />}
      </MobilePageWrapper>
    </>
  );
};

export default Mobile;
